import { useContext, useState } from "react";
import axios from "../axios";
import { toast } from "sonner";
import { UserContext } from "../../components/context/UseContext";
import { useProfile } from "./profile";
import { useNavigate } from "react-router-dom";

export const useSecurity = () => {
  const { token } = useContext(UserContext);
  const { getProfileInfo } = useProfile();
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [gettingOtp, setGettingOtp] = useState(false);
  const [validating, setValidating] = useState(false);
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [oldPin, setOldPin] = useState("");
  const [otp, setOtp] = useState("");
  const [canChangePin, setCanChangePin] = useState(false);

  const handleChangePassword = async () => {
    try {
      setLoading(true);
      const res = await axios.patch(
        "/audiences/account-settings/security/change-password",
        JSON.stringify({
          old_password: oldPassword,
          password: password,
          password_confirmation: passwordConfirm,
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      if (res.status === 200) {
        setLoading(false);
        setOldPassword("");
        setPassword("");
        setPasswordConfirm("");
        toast.success(res.data.message);
        navigate("/settings");
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };

  const handleSetPin = async () => {
    try {
      setLoading(true);
      const res = await axios.patch(
        "/audiences/account-settings/profile/set-pin",
        JSON.stringify({
          pin: pin,
        })
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setLoading(false);
        setPin("");
        await getProfileInfo(token, true);
        return true;
      }
      return false;
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
      return false;
    }
  };
  const handleChangePin = async () => {
    try {
      setLoading(true);
      const res = await axios.patch(
        "/audiences/account-settings/profile/change-pin",
        JSON.stringify({
          pin: pin,
          old_pin: oldPin,
        })
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setLoading(false);
        setPin("");
        setOldPin("");
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
    }
  };
  const handleResetPin = async () => {
    try {
      setLoading(true);
      const res = await axios.patch(
        "/audiences/account-settings/profile/forgot-pin",
        JSON.stringify({
          new_pin: pin,
          new_pin_confirmation: confirmPin,
        })
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setLoading(false);
        return true;
      }
      return false;
    } catch (error) {
      toast.error(error.response.data.message);
      setLoading(false);
      return false;
    }
  };
  const handleGetOtp = async () => {
    try {
      setGettingOtp(true);
      const res = await axios.get(
        "/audiences/account-settings/profile/get-otp"
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setGettingOtp(false);
        return true;
      }

      return false;
    } catch (error) {
      toast.error(error.response.data.message);
      setGettingOtp(false);
      return false;
    }
  };
  const handleValidatetOtp = async () => {
    try {
      setValidating(true);
      const res = await axios.post(
        "/audiences/account-settings/profile/validate-otp",
        JSON.stringify({
          otp: otp,
        })
      );
      if (res.status === 200) {
        toast.success(res.data.message);
        setCanChangePin(true);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setValidating(false);
    }
  };

  // OLD IMPLEMENTATION
  // const handleChangePin = async () => {
  //   try {
  //     setLoading(true);
  //     const res = await axios.patch(
  //       "/audiences/account-settings/profile/pin",
  //       JSON.stringify({
  //         pin: pin,
  //       }),
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //     if (res.status === 200) {
  //       toast.success(res.data.message);
  //       setLoading(false);
  //       setPin("");
  //     }
  //   } catch (error) {
  //     toast.error(error.response.data.message);
  //     setLoading(false);
  //   }
  // };

  return {
    handleChangePassword,
    oldPassword,
    setOldPassword,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    loading,
    handleSetPin,
    pin,
    setPin,
    handleChangePin,
    setOldPin,
    oldPin,
    setOtp,
    otp,
    handleResetPin,
    handleValidatetOtp,
    handleGetOtp,
    canChangePin,
    gettingOtp,
    setConfirmPin,
    confirmPin,
    validating,
  };
};
